(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guide-article"]) return;
  try {
    
  if (!customElements.get('lh-guide')) {
    class LhGuide extends HTMLElement {
      connectedCallback() {
        this.frame = 0;
        this.onScroll = this.onScroll.bind(this);
        this.bar = this.querySelector('[data-lh-progress]');
        this.links = Array.from(this.querySelectorAll('[data-lh-toc-link]'));
        this.targets = Array.from(new Set(this.links.map((link) => link.getAttribute('href').slice(1))))
          .map((id) => document.getElementById(id))
          .filter(Boolean);

        if (this.bar) this.bar.hidden = false;
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });

        if (this.targets.length && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(() => this.onScroll(), {
            rootMargin: '0px 0px -60% 0px',
          });
          this.targets.forEach((target) => this.observer.observe(target));
        }

        const sheet = this.querySelector('[data-lh-sheet]');
        if (sheet) {
          sheet.addEventListener('click', (event) => {
            if (event.target.closest('[data-lh-toc-link]')) sheet.open = false;
          });
          sheet.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && sheet.open) {
              sheet.open = false;
              sheet.querySelector('summary').focus();
            }
          });
        }

        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.observer) this.observer.disconnect();
        cancelAnimationFrame(this.frame);
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }

      update() {
        if (this.bar) {
          const rect = this.getBoundingClientRect();
          const total = rect.height - window.innerHeight;
          const progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
          this.bar.style.setProperty('--lh-progress', progress.toFixed(4));
        }

        if (!this.targets.length) return;
        const line = window.innerHeight * 0.4;
        let activeId = '';
        for (const target of this.targets) {
          if (target.getBoundingClientRect().top <= line) activeId = target.id;
        }
        this.links.forEach((link) => {
          const isActive = activeId !== '' && link.getAttribute('href') === `#${activeId}`;
          link.classList.toggle('is-active', isActive);
          if (isActive) {
            link.setAttribute('aria-current', 'location');
          } else {
            link.removeAttribute('aria-current');
          }
        });
      }
    }

    customElements.define('lh-guide', LhGuide);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
